// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34DNC","col":"styles_col__3WJP3"};